import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class LeadAssignmentQueueResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                unassigned_leads: [{
                    id: 'b7f0c2de-5a3e-4c1a-9a4e-3f6f1f0d2a11',
                    fantasy_name: "Michael's Bakery",
                    phone: '1122334455',
                    email: 'michael@dundermifflin.com',
                    origin_channel: 'WhatsApp',
                    how_they_knew_us: 'Meta',
                    referral_observation: '',
                    commerce_type: 'Panadería',
                    commerce_type_specification: '',
                    interest_products: ['Panes'],
                    commercial_channel: 'Horeca',
                    business_name: 'Dunder Mifflin',
                    taxpayer_identification_number: '30712345678',
                    belongs_to_a_disabled_customer: false,
                    franchise_brand_name: null,
                    creation_datetime: '2026-10-17T14:30:00-03:00',
                    stage: 'UNASSIGNED',
                    has_responsible: false,
                    responsible: null,
                    lead_delivery_sites: [],
                }],
                closers_workloads: [{
                    closer_email: 'closer@saporedipane.com',
                    closer_name: 'Jim Halpert',
                    active_leads_count: 4,
                }],
                assignees: [
                    {email: 'closer@saporedipane.com', name: 'Jim Halpert', is_the_assigner: false},
                    {email: 'horeca-head@saporedipane.com', name: 'Dwight Schrute', is_the_assigner: true},
                ],
            },
            errors: [],
        };
    }

    unassignedLeads() {
        return this.content().unassigned_leads.map((lead) => ({
            id: lead.id,
            fantasyName: lead.fantasy_name,
            originChannel: lead.origin_channel,
            creationDatetime: new Date(lead.creation_datetime),
        }));
    }

    closersWorkloads() {
        return this.content().closers_workloads.map((closerWorkload) => ({
            closerEmail: closerWorkload.closer_email,
            closerName: closerWorkload.closer_name,
            activeLeadsCount: closerWorkload.active_leads_count,
        }));
    }

    assignees() {
        return this.content().assignees.map((assignee) => ({
            email: assignee.email,
            name: assignee.name,
            isTheAssigner: assignee.is_the_assigner,
        }));
    }
}
